import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";

type TPaginationProps = {
  page: number;
  total: number;
  pageSize: number;
  hasPrev: boolean;
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  className?: string;
};

export function Pagination({ page, total, pageSize, hasPrev, hasNext, onPrev, onNext, className }: TPaginationProps) {
  if (total <= pageSize) return null;

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return (
    <div className={cn("flex items-center justify-between border-t border-border px-6 py-4", className)}>
      <div className="text-sm text-foreground">
        Showing {start} to {end} of {total}
      </div>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onPrev}
          disabled={!hasPrev}
        >
          Previous
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onNext}
          disabled={!hasNext}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
